import React, {useEffect, useState} from "react";


import "./Menu.css";

import {Button, Container, Nav, Navbar} from "react-bootstrap";
import {Link, withRouter} from "react-router-dom";
import IssueCreationModal from "../../components/IssueCreationModal";
import config from "./MenuConfig";
import {hasPermission} from "../../helpers/jwt";
import {AppInfo} from "./AppInfo";
import Tooltip from "../../components/tooltip/Tooltip";
import useMenuConfig from "./MenuConfig";

const toggleJsUrl = "/assets/js/toggle.js";
const logoImage = "/assets/img/blister_logo.png";


const Menu = (props) => {

    const [showIssueModal, setShowIssueModal] = useState(false);


    const initToggleScript = () => {
        const script = document.createElement("script");

        script.src = toggleJsUrl;
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    };



    useEffect(() => {
        initToggleScript();
    }, []);


    function handleMainPage() {
        props.history.push("/");
    }


    return (
        <>
            <Navbar variant="dark" fixed="top"
                    className="Menu__wrapper align-items-start sidebar sidebar-dark accordion">
                <Container fluid className="d-flex flex-column p-0">
                    <Button variant="link" className="d-md-none rounded-circle mr-3" id="sidebarToggleTop"
                            type="button">
                        <i className="fas fa-bars"/>
                    </Button>
                    <img src={logoImage} className="Navigation__logo mt-2" alt="main logo" onClick={handleMainPage}/>

                    <Nav className="nav text-light mt-2" id="accordionSidebar-1">
                        {useMenuConfig()
                            .filter(c => c.permission ? hasPermission(c.permission) : true)
                            .map(c =>

                                <Nav.Item role="presentation">
                                    <Link className="nav-link notToggled" to={c.navigate}>
                                        <i className={`fas ${c.icon}`}/>
                                        <span>{c.title}</span>
                                    </Link>
                                    <Link className="nav-link toggled" to={c.navigate}>
                                        <Tooltip tooltip={c.title}>
                                            <i className={`fas ${c.icon}`}/>
                                        </Tooltip>
                                    </Link>
                                </Nav.Item>
                            )}
                    </Nav>
                    <AppInfo/>
                </Container>
            </Navbar>
            <IssueCreationModal show={showIssueModal} setShow={setShowIssueModal}/>
        </>
    );
};

export default withRouter(Menu);